'use client';

import routes from 'src/routes';

import { useTranslations } from 'next-intl';

import CustomLink from 'src/components/CustomLink';
import Error401 from './Error400Buttons/Error401';
import Error403 from './Error400Buttons/Error403';
import Error404 from './Error400Buttons/Error404';

export default function Error400({ code }: { code: number }) {
  const t = useTranslations('error');

  let Error400Buttons;

  switch (code) {
    case 401: {
      Error400Buttons = <Error401 />;
      break;
    }
    case 403: {
      Error400Buttons = <Error403 />;
      break;
    }
    // default is 404 case - render a simple navigate home button
    default: {
      Error400Buttons = <Error404 />;
      break;
    }
  }

  return (
    <main className="usa-section usa-prose">
      <div className="grid-container">
        <h1 className="usa-display">{t(`${code}.title`)}</h1>

        <p className="usa-intro text-lg">{t(`${code}.description`)}</p>

        <p className="text-sm">
          {t(`${code}.guidance`)}{' '}
          {code === 404 && (
            <strong>{t('404.url', { homeMyChildCareMA: routes.external.massgov.homeMyChildCareMA })}</strong>
          )}
        </p>
        <p className="text-sm">
          {t.rich(`${code}.support`, {
            telephone_link: () => (
              <CustomLink href={`tel:${routes.external.phones.mass_211_contact_number}`}>
                {routes.external.phones.mass_211_contact_number}
              </CustomLink>
            ),
          })}
        </p>

        <div className="margin-top-4">{Error400Buttons}</div>

        <div className="margin-top-4">
          <p>{t('contact.assistance')}</p>
          <ul>
            <li>
              {t.rich('contact.call', {
                link: () => (
                  <CustomLink href={`tel:${routes.external.phones.mass_211_contact_number}`}>
                    {routes.external.phones.mass_211_contact_number}
                  </CustomLink>
                ),
              })}
            </li>
          </ul>
        </div>

        <p className="margin-top-4 text-base">{t('error_code', { code: code })}</p>
      </div>
    </main>
  );
}
